import { useFormik } from 'formik'
import { hv_vehicle_weight_option, vehicle_models_edit, hv_availabilities_option, hv_vehicle_type_option } from 'pages/Vehicle/helpers/hv_helper'
import { vehicle_models } from 'pages/Vehicle/helpers/hv_Data'
import { useEffect, useState } from 'react'
import _ from 'lodash'

const useVehicleResult = () => {
  const vehicle_data = vehicle_models_edit(vehicle_models)
  const [vehicle_models_data, set_vehicle_models_data] = useState(() => vehicle_data)
  const [hvVehicleWeightClass] = useState([...hv_vehicle_weight_option(vehicle_data)])

  const formik = useFormik({
    initialValues: { heavy_vehicle_weight_class: '', heavy_vehicle_type: '', heavy_vehicle_availability: 'Available now' },
    onSubmit: () => {},
  })

  useEffect(() => {
    const weight_class = formik?.values?.heavy_vehicle_weight_class
    const vehicle_type = formik?.values?.heavy_vehicle_type
    const availability = formik?.values?.heavy_vehicle_availability

    set_vehicle_models_data(
      () => _.filter(
        vehicle_data,
        (item: any) =>
          (weight_class ? item.heavy_vehicle_weight_class === weight_class : true) &&
          (vehicle_type ? item.type === vehicle_type : true) &&
          (availability ? item.availability === availability : true),
      ),
    )
  }, [formik.values, vehicle_models]) //eslint-disable-line

  return {
    formik,
    hvVehicleWeightClass: hvVehicleWeightClass,
    hvAvailabilityOptions: hv_availabilities_option(vehicle_data),
    hvVehicleTypeOptions: hv_vehicle_type_option(vehicle_data),
    vehicle_models_data,
  }
}

export default useVehicleResult
